import { Component, OnInit, Input } from '@angular/core';

import { StatusService } from '../Services/status.service';
import { AuthService } from '../Services/auth.service';
import { Logininfo } from '../classes/Loginifo';

@Component({
  selector: 'app-personal-target',
  templateUrl: './personal-target.component.html',
  styleUrls: ['./personal-target.component.css']
})
export class PersonalTargetComponent implements OnInit {
  @Input() user_code: number;
  @Input() year: number;
  @Input() month: number;

  logininfo: Logininfo = this.authService.loginID;
  weekNo;
  recordList: any;
  edit;
  prevRecord;
  nowRecord;

  constructor(
    private statusService: StatusService,
    public authService: AuthService,
  ) { }

  ngOnInit() {
    //this.year = new Date().getFullYear();
    //this.month = new Date().getMonth() + 1;
    this.changeRecord();
  }

  checkWeekNo(weekNo, date) {
    let week = 1;
    if (weekNo[week].start > date) {
      return week;
    }
    while (weekNo[week].end < date) {
      week++;
      if (weekNo.length <= week) {
        break;
      }
    }
    return week;
  }

  //その月に何周あるか計算
  getWeekNo(year, month) {
    if (month < 7) year++;
    let now = new Date(year, month - 1, 1);
    let dt = new Date(year, month - 1, 1);

    // dtを指定月の最初の週の開始日にする
    let mon = dt.getDay();
    if (mon > 1) {
      dt.setDate(dt.getDate() + (8 - dt.getDay()));
    } else if (mon == 0) {
      dt.setDate(dt.getDate() + 1)
    }

    let weeksOfMonth = [];
    let weekNo = 1;
    while (dt.getMonth() == now.getMonth()) {
      weeksOfMonth[weekNo++] = { 'start': new Date(dt), 'end': new Date(dt.setDate(dt.getDate() + 6)) };
      dt.setDate(dt.getDate() + 1);
    }
    return weeksOfMonth;
  }

  // 投げられた年月の実績を取得
  @Input('month')
  set changemonth(month: number) {
    this.month = month;
    if (this.year && this.month) {
      this.SearchRecord();
    }
  }
  SearchRecord() {
    this.weekNo = this.checkWeekNo(this.getWeekNo(this.year, this.month), new Date());
    let year = this.year;
    if (this.month < 7) year++;
    let checkYm = year + '' + (('0' + this.month).slice(-2));

    let nowYm = (new Date().getFullYear()) + '' + ('0' + (new Date().getMonth() + 1)).slice(-2);
    if (this.recordList) {
      if (nowYm > checkYm) {
        this.edit = false;
      } else {
        this.edit = true;
      }
      let prevMonth = this.month == 1 ? 12 : this.month - 1;
      let prevYear = this.month == 7 ? this.year - 1: this.year;
      this.nowRecord = this.recordList.filter((item) => (item.year_term == this.year && item.month == this.month));
      this.prevRecord = this.recordList.filter((item) => (item.year_term == prevYear && item.month == prevMonth));
    }
  }

  //指定年度のレコード取得
  @Input('year')
  set changeYear(year: number) {
    this.year = year;
    this.changeRecord();
  }
  changeRecord() {
    this.recordList = null;
    this.prevRecord = null;
    this.nowRecord = null;

    this.statusService.getPersonalStatusList(this.user_code, this.year).subscribe(res => {
      this.recordList = res;
      this.SearchRecord();
    });
  }

  //月間目標を各週に割振り
  Allocation() {
    let week = this.nowRecord.length - this.weekNo;
    let new_temp = this.nowRecord[0].new_target;
    let ap_temp = this.nowRecord[0].ap_target;
    let app_temp = this.nowRecord[0].app_target;
    let contract_temp = this.nowRecord[0].contract_target;
    for (let i = 1; i < this.nowRecord.length; i++) {
      //再設定した目標から現実績を引く
      if (i < this.weekNo) {
        new_temp -= this.nowRecord[i].new_actual;
        if (new_temp < 0) new_temp = 0;
        ap_temp -= this.nowRecord[i].ap_actual;
        if (ap_temp < 0) ap_temp = 0;
        app_temp -= this.nowRecord[i].app_result;
        if (app_temp < 0) app_temp = 0;
        contract_temp -= this.nowRecord[i].contract_record;
        if (contract_temp < 0) contract_temp = 0;
      } else {
        //残りの週に割振
        this.nowRecord[i].new_target = new_temp / week;
        this.nowRecord[i].ap_target = ap_temp / week;
        this.nowRecord[i].app_target = app_temp / week;
        this.nowRecord[i].contract_target = contract_temp / week;
      }
    }
  }

  sumWeek() {
    let new_target = 0;
    let ap_target = 0;
    let app_target = 0;
    let contract_target = 0;
    this.nowRecord.forEach((val, idx) => {
      if (idx != 0) {
        new_target += val.new_target;
        ap_target += val.ap_target;
        app_target += val.app_target;
        contract_target += val.contract_target;
      }
    });
    this.nowRecord[0].new_target = new_target;
    this.nowRecord[0].ap_target = ap_target;
    this.nowRecord[0].app_target = app_target;
    this.nowRecord[0].contract_target = contract_target;
  }

  save() {
    return this.statusService.updatePersonalStatus(this.nowRecord);
  }
}
